
<div class="geo_spatial tab_content" id="content4" data-tab="4">

  <mat-button-toggle-group
  name="fontStyle"
  aria-label="Font Style"
  color="accent"
  class="m-3"

  >
  <mat-button-toggle value="list" color="accent"
  (click)="onToggleMap('custom')"
  >
    Custom Map
    </mat-button-toggle
  >
  <mat-button-toggle value="grid"
  (click)="onToggleMap('dynamic')"
    >
    Dynamic Map
    </mat-button-toggle
  >
  </mat-button-toggle-group>

  <div class="geo_main-content" *ngIf="toggleMap === 'custom'">
    <h2>Custom Map</h2>
    <div class="map_record">
      <div class="map_detail" *ngFor="let landParcel of selectedLandTitle.landParcels; index as i">
        <p class="row_id">
          <span class="label">Row ID</span>
          <span class="the_id">{{landParcel.RowIdLinkage}}</span>
        </p>
        <p class="purpose">
          <span class="label">Purpose</span>
          <a class="the_id" href="{{ appConfig.leftvalue + landParcel.URLMap}}" target="_blank">{{getPurposeName(landParcel.PurposeId)}}</a>
          <!-- <span class="the_id">Borrow pit</span> -->
        </p>
        <p class="row_id">
          <span class="label">Section Name</span>
          <a class="the_id" href="{{appConfig.leftvalue + landParcel.URLMap}}" target="_blank">{{landParcel.SectionName}}</a>
          <!-- <span class="the_id">Borrow Pit for Kolo Creel Well 34</span> -->
        </p>
      </div>

    </div>
  </div>

  <div class="geo_main-content" *ngIf="toggleMap === 'dynamic'">
    <h2>Dynamic Map</h2>
    <div class="map_record">
      <div class="map_detail" *ngFor="let appConfig of filteredAppConfigs; index as i">
        <p class="row_id">
          <span class="label">Map Link</span>
          <!-- <span class="the_id">{{appConfig.leftValue}}</span> -->
          <a class="the_id" href="{{appConfig.leftvalue}}" target="_blank">{{appConfig.leftvalue}}</a>
        </p>
        <!-- <p class="purpose">
          <span class="label">Purpose</span>
          <a class="the_id" href="{{landParcel.URLMap}}" target="_blank">{{getPurposeName(landParcel.PurposeId)}}</a>

        </p>
        <p class="row_id">
          <span class="label">Section Name</span>
          <a class="the_id" href="{{landParcel.URLMap}}" target="_blank">{{landParcel.SectionName}}</a>

        </p> -->
      </div>

    </div>
  </div>
</div>
